/*
 * @Author: zyy
 * @Date: 2022-11-11 17:48:23
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-11 18:31:42
 * @Description: default
 */
import Axios from 'axios';
import Qs from 'qs'

export default {
    list(params){
        return Axios.get('/community/advert/list',{
            params
        })
    },
    add(params){
        return Axios.post('/community/advert/store',params)
    },
    edit(params){
        return Axios.post(`/community/advert/update/${params.id}`,params)
    },
    del(params){
        return Axios.delete(`/community/advert/delete/${params.id}`,params)
    }
}